<template>
  <div class="termos-page container-fluid min-vh-100">
    <div class="row min-vh-100 justify-content-center">
      <div class="col-12 col-lg-8 d-flex justify-content-center">
        <div class="termos-card w-100">

          <!-- VOLTAR -->
          <router-link to="/create-account" class="voltar mb-4 d-inline-flex align-items-center">
            <b>← Voltar</b>
          </router-link>

          <!-- TÍTULO -->
          <div class="page-header">
            <p class="page-header-eyebrow">LEGAL</p>
            <h3 class="fw-bold mb-2"><b>Termos de Uso</b></h3>
            <p class="text-muted mb-4">
              Última atualização: {{ dataAtual }}
            </p>
          </div>

          <!-- CONTEÚDO -->
          <div class="termos-conteudo">

            <h5>1. Aceitação dos Termos</h5>
            <p>
              Ao acessar ou utilizar esta plataforma, o usuário declara ter lido,
              compreendido e aceitado integralmente estes Termos de Uso.
            </p>

            <h5>2. Descrição do Serviço</h5>
            <p>
              Esta é uma plataforma voltada a engenheiros, que oferece gerenciamento
              de projetos técnicos, organização por componentes e calculadoras de
              vasos de pressão conforme a <b>NR-13</b>.
            </p>

            <h5>3. Cadastro e Responsabilidades</h5>
            <p>
              O usuário é responsável pelas informações fornecidas, pela segurança de
              suas credenciais e pela validação técnica dos dados inseridos.
            </p>

            <h5>4. Uso das Calculadoras NR-13</h5>
            <p>
              As calculadoras têm caráter auxiliar e não substituem análise técnica,
              laudos, ARTs ou responsabilidade de profissionais habilitados.
            </p>

            <h5>5. Projetos e Compartilhamento</h5>
            <p>
              Os projetos pertencem ao usuário criador e podem ser compartilhados com
              outros usuários conforme permissões concedidas.
            </p>

            <h5>6. Plano Pro e Assinatura</h5>
            <p>
              O acesso à plataforma é realizado por meio do plano Pro, com cobrança
              recorrente conforme as condições informadas no momento da contratação.
            </p>

            <h5>7. Pagamentos e Cancelamento</h5>
            <p>
              O usuário pode cancelar a assinatura a qualquer momento, mantendo o
              acesso até o fim do período já pago. Para encerrar a conta, o usuário
              deve solicitar o encerramento ao suporte por e-mail ou WhatsApp, por
              meio dos canais oficiais informados pela WiseCalc.
            </p>

            <h5>9. Suspensão de Conta</h5>
            <p>
              Contas que violem estes termos poderão ser suspensas ou encerradas.
            </p>

            <h5>10. Propriedade Intelectual</h5>
            <p>
              Todo o sistema, incluindo interface, código e lógica das calculadoras,
              é protegido por direitos autorais.
            </p>

            <h5>11. Limitação de Responsabilidade</h5>
            <p>
              A plataforma não se responsabiliza por decisões técnicas tomadas com base
              nos dados fornecidos.
            </p>

            <h5>12. Alterações</h5>
            <p>
              Estes termos podem ser alterados a qualquer momento, com aviso prévio
              dentro da plataforma.
            </p>

            <h5>13. Legislação Aplicável</h5>
            <p>
              Estes termos são regidos pelas leis brasileiras.
            </p>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Termos",
  mounted() {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  },
  computed: {
    dataAtual() {
      return new Date().toLocaleDateString("pt-BR");
    }
  }
};
</script>

<style scoped>
.termos-page {
  background: #ffffff;
}

.termos-card {
  max-width: 720px;
  padding: 32px;
}

.voltar {
  color: #0056ff;
  text-decoration: none;
  font-weight: 500;
}

.voltar:hover {
  text-decoration: underline;
}

.termos-conteudo {
  /* max-height: 65vh;
  overflow-y: auto; */
  padding-right: 8px;
}

.termos-conteudo h5 {
  margin-top: 24px;
  font-weight: 700;
}

.termos-conteudo p {
  color: #555;
  font-size: 0.95rem;
  line-height: 1.6;
}
</style>
